import { useEffect, useState } from "react";

const parseExpiration = (expiration?: string | null): number | null => {
  if (!expiration) return null;
  const hasZone = /([zZ]|[+-]\d{2}:?\d{2})$/.test(expiration);
  const ms = Date.parse(hasZone ? expiration : `${expiration}Z`);
  return Number.isNaN(ms) ? null : ms;
};

export const useIsQrExpired = (expiration?: string | null): boolean => {
  const expiresAt = parseExpiration(expiration);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (expiresAt === null) return;
    const remaining = expiresAt - Date.now();
    if (remaining <= 0) {
      setNow(Date.now());
      return;
    }
    const delay = remaining + 50;
    const id = window.setTimeout(() => setNow(Date.now()), delay);
    return () => window.clearTimeout(id);
  }, [expiresAt, now]); // re-arms after each tick, so early firing self-corrects

  useEffect(() => {
    const refresh = () => {
      if (document.visibilityState === "visible") setNow(Date.now());
    };
    document.addEventListener("visibilitychange", refresh);
    window.addEventListener("focus", refresh);
    return () => {
      document.removeEventListener("visibilitychange", refresh);
      window.removeEventListener("focus", refresh);
    };
  }, []);

  return expiresAt !== null && expiresAt <= now;
};
